import { css } from '@emotion/react';
import { Colors } from '@zapier/design-system';
import { isolateComponent } from '@zapier/style-encapsulation';
import { Fragment } from 'react';
import { ArticlePromo } from './ArticlePromo';
import { ListPromo } from './ListPromo';
const Styles = {
    root: css({
        display: 'flex',
        flexDirection: 'column',
    }),
    divider: css({
        backgroundColor: Colors.neutral500,
        height: 1,
        margin: '20px 0',
        '&:last-of-type': {
            display: 'none',
        },
    }),
};
export const Promo = (props) => {
    const { promo } = props;
    return promo ? (isolateComponent("div", { css: Styles.root, "data-testid": "promo" }, promo.map((item, index) => (isolateComponent(Fragment, { key: `${item.type}-${index}` },
        item.type === 'article-stub' ? (isolateComponent(ArticlePromo, Object.assign({}, item, { onCloseMenu: props.onCloseMenu }))) : (isolateComponent(ListPromo, Object.assign({}, item, { onCloseMenu: props.onCloseMenu }))),
        isolateComponent("hr", { css: Styles.divider })))))) : null;
};
//# sourceMappingURL=Promo.js.map
// @zapier/universal-layout@8.3.1 (41acce620)
